import React from 'react';
import { render } from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import serverVars from 'server-vars';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import {
    GDPR_KEY_AGREED,
    GDPR_KEY_NOT_APPLICABLE,
} from '../components/CookieNotification/constants';
import { shouldDisableNotifications } from '../utils/notificationsHelper';

const getBuyerCookieNotificationClient = ({ node, relayEnv }) => {
    const isLocalSet = !!localStorage.getItem(GDPR_KEY_AGREED);
    const isSessionSet = !!sessionStorage.getItem(GDPR_KEY_NOT_APPLICABLE);

    if (isSessionSet || isLocalSet || shouldDisableNotifications()) {
        return;
    }

    const cookiePromise = import(
        /* webpackChunkName: "cookieNotification" */ '../components/cookieNotification'
    );

    cookiePromise.then(({ cookieNotificationRootQuery, CookieNotificationRenderer }) => {
        const localeDataKey = serverVars.get('localeDataKey');
        const messages = serverVars.get('messages');

        if (window.ReactIntlLocaleData) {
            addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
        }

        render(
            <IntlProvider locale={localeDataKey} messages={messages}>
                <CookieNotificationRenderer
                    environment={relayEnv}
                    query={cookieNotificationRootQuery}
                />
            </IntlProvider>,
            node
        );
    });
};

export { getBuyerCookieNotificationClient };
